import { c as _c } from "react/compiler-runtime";
import { Spinner } from '@/components/ui/spinner';
type PropsType = {
  size?: 'small' | 'medium' | 'large';
  message?: string;
  className?: string;
};
const LoadingIndicator = t0 => {
  const $ = _c(8);
  const {
    size: t1,
    message,
    className
  } = t0;
  const size = t1 === undefined ? "medium" : t1;
  const t2 = `flex flex-col items-center gap-2${className ? ` ${className}` : ""}`;
  let t3;
  if ($[0] !== size) {
    t3 = <Spinner size={size} className="text-gray-500" />;
    $[0] = size;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== message) {
    t4 = message && <span className="text-gray-500">{message}</span>;
    $[2] = message;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export default LoadingIndicator;